/** Utility functions for waiting for something to be true before executing a callback */
/** On the server this just returns provider immediately   */
const FluentWaitUtil = {
  /**
   * Poll provider every `timeBetweenChecksInMilliseconds`for a non-falsy value.
   * Resolve to that value unless tried `maxTries` times, in which case reject.
   */
  whileNotFalsy<T>({
    provider,
    timeBetweenChecksInMilliseconds,
    maxTries,
  }: {
    provider: () => T;
    timeBetweenChecksInMilliseconds: number;
    maxTries: number;
  }): Promise<T> {
    // setinterval is not available on the server, so we just return the provider immediately
    if (import.meta.server) {
      return Promise.resolve(provider());
    }
    const initTry = provider();
    if (initTry) {
      return Promise.resolve(initTry);
    }

    return new Promise((res, rej) => {
      let curTry = maxTries;
      const interval = setInterval(() => {
        const result = provider();
        if (result) {
          clearInterval(interval);
          res(result);
        }
        curTry -= 1;
        if (curTry < 1) {
          clearInterval(interval);
          rej();
        }
      }, timeBetweenChecksInMilliseconds);
    });
  },

  /** Just wait `waitMilliseconds` before resolving */
  waitMilliseconds(waitMilliseconds: number): Promise<void> {
    return new Promise((res) => {
      setTimeout(() => res(), waitMilliseconds);
    });
  },
};

export default FluentWaitUtil;
